<template>
  <span
    class="z-badge-text"
    :class="customColor"
    v-if="hasTag"
  >
    {{ label }}
  </span>
</template>
<script>

export default {
  props: {
    bill: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      labels: {
        pending: 'Atrasada',
        exempted: 'Isenta',
      },
    };
  },
  computed: {
    hasTag() {
      return this.label && (this.isBillExempted || (this.isIgnored && !this.isPaidToThirdParty) || this.isPending);
    },
    ignoredReason() {
      return this.bill.ignored_reason;
    },
    customColor() {
      if (this.isPending) {
        return 'z-badge-text--danger';
      }

      if (this.isIgnored) {
        return 'z-badge-text--info';
      }

      return null;
    },
    label() {
      if (this.isBillExempted) {
        return this.labels.exempted;
      } if (this.isIgnored && this.ignoredReason) {
        return this.ignoredReason.translated_key;
      } if (this.isPending) {
        return this.labels.pending;
      }

      return null;
    },
    isBillExempted() {
      return this.bill.status === 'paid' && this.bill.bill_value === '0.0';
    },
    isIgnored() {
      return this.bill.status === 'ignored';
    },
    isPending() {
      return this.bill.status === 'pending';
    },
    isPaidToThirdParty() {
      return this.ignoredReason.key === 'paid_by_third_party';
    },
  },
};
</script>
